import { sub, getTime } from 'date-fns';
import EnvironmentManager from 'Utils/environmentManager';

export const ACTIVITY_FILTER_ITEMS = [
  { key: 'ALL', value: 'Tümü' },
  { key: 'INCOMING', value: 'Gelen Tutar' },
  { key: 'OUTGOING', value: 'Giden Tutar' },
  { key: 'IDDAA', value: 'İddaa' },
  { key: 'TJK', value: EnvironmentManager.getMessageText({ key: 'title_transaction_tjk' }) || 'At Yarışı' },
  { key: 'DIGITAL_GAMES', value: EnvironmentManager.getMessageText({ key: 'title_transaction_digital_games' }) || 'Şans Oyunları' },
  { key: 'VIRTUAL_GAMES', value: EnvironmentManager.getMessageText({ key: 'title_transaction_virtual_games' }) || 'Sanal Bahis' },
  { key: 'SPORTOTO', value: 'Spor Toto' },

];

export const PERIOD_FILTER_ITEMS = [
  { key: getTime(sub(new Date(), { days: 3 })).toString(), value: 'Son 3 Gün' },
  { key: getTime(sub(new Date(), { weeks: 1 })).toString(), value: 'Son 1 Hafta' },
  { key: getTime(sub(new Date(), { months: 1 })).toString(), value: 'Son 1 Ay' },
  { key: getTime(sub(new Date(), { months: 6 })).toString(), value: 'Son 6 Ay' },
  { key: getTime(sub(new Date(), { years: 1 })).toString(), value: 'Son 1 Yıl' },
];

export const TRANSACTION_TYPES = {
  IDDAA_PLAY: 'IDDAA_PLAY',
  IDDAA_MULTIPLE_PLAY: 'IDDAA_MULTIPLE_PLAY',
  IDDAA_WON: 'IDDAA_WON',
  IDDAA_MANUEL_CANCEL: 'IDDAA_MANUEL_CANCEL',
  IDDAA_ROLLBACK: 'IDDAA_ROLLBACK',
  IDDAA_CANCEL: 'IDDAA_CANCEL',
  SPORTOTO_PLAY: 'SPORTOTO_PLAY',
  SPORTOTO_WON: 'SPORTOTO_WON',
  SPORTOTO_CANCEL: 'SPORTOTO_CANCEL',
  BILYONCARD_DEPOSIT: 'BILYONCARD_DEPOSIT',
  BONUS_DEPOSIT: 'BONUS_DEPOSIT',
  BONUS_DRAW: 'BONUS_DRAW',
  CUSTOMER_CARE_BONUS_DEPOSIT: 'CUSTOMER_CARE_BONUS_DEPOSIT',
  CUSTOMER_CARE_MONEY_DEPOSIT: 'CUSTOMER_CARE_MONEY_DEPOSIT',
  CUSTOMER_CARE_BONUS_DRAW: 'CUSTOMER_CARE_BONUS_DRAW',
  CUSTOMER_CARE_MONEY_DRAW: 'CUSTOMER_CARE_MONEY_DRAW',
  BANK_DEPOSIT: 'BANK_DEPOSIT',
  BANK_GATEWAY_DEPOSIT: 'BANK_GATEWAY_DEPOSIT',
  AKBANK_EFT_DEPOSIT: 'AKBANK_EFT_DEPOSIT',
  BANK_DEPOSIT_ATM_CARDLESS: 'BANK_DEPOSIT_ATM_CARDLESS',
  BANK_GATEWAY_DEPOSIT_ATM_CARDLESS: 'BANK_GATEWAY_DEPOSIT_ATM_CARDLESS',
  BANK_DEPOSIT_ATM_CARDLESS_REFUND: 'BANK_DEPOSIT_ATM_CARDLESS_REFUND',
  BANK_GATEWAY_DEPOSIT_ATM_CARDLESS_REFUND: 'BANK_GATEWAY_DEPOSIT_ATM_CARDLESS_REFUND',
  CANCELATION_OF_MEMBERSHIP_REFUND: 'CANCELATION_OF_MEMBERSHIP_REFUND',
  ONLINE_WITHDRAW: 'ONLINE_WITHDRAW',
  WITHDRAW: 'WITHDRAW',
  WITHDRAW_CANCEL: 'WITHDRAW_CANCEL',
  ONLINE_WITHDRAW_ROLLBACK: 'ONLINE_WITHDRAW_ROLLBACK',
  WITHDRAW_REFUND: 'WITHDRAW_REFUND',
  SG_DUPLICATE_PAYMENT: 'SG_DUPLICATE_PAYMENT',
  FRAUD: 'FRAUD',
  AUTOMATED_WITHDRAW: 'AUTOMATED_WITHDRAW',
  OPERATION_WITHDRAW: 'OPERATION_WITHDRAW',
  OPERATION_DEPOSIT: 'OPERATION_DEPOSIT',
  TJK_WON: 'TJK_WON',
  TJK_PLAY: 'TJK_PLAY',
  TJK_CANCEL: 'TJK_CANCEL',
  TJK_ROLLBACK: 'TJK_ROLLBACK',
};

export const DETAILED_TRANSACTION_TYPES = {
  [TRANSACTION_TYPES.WITHDRAW]: TRANSACTION_TYPES.WITHDRAW,
  [TRANSACTION_TYPES.IDDAA_WON]: TRANSACTION_TYPES.IDDAA_WON,
  [TRANSACTION_TYPES.ONLINE_WITHDRAW_ROLLBACK]: TRANSACTION_TYPES.ONLINE_WITHDRAW_ROLLBACK,
  [TRANSACTION_TYPES.ONLINE_WITHDRAW]: TRANSACTION_TYPES.ONLINE_WITHDRAW,
  [TRANSACTION_TYPES.WITHDRAW_REFUND]: TRANSACTION_TYPES.WITHDRAW_REFUND,
  [TRANSACTION_TYPES.SPORTOTO_WON]: TRANSACTION_TYPES.SPORTOTO_WON,
  [TRANSACTION_TYPES.BANK_GATEWAY_DEPOSIT_ATM_CARDLESS]: TRANSACTION_TYPES.BANK_GATEWAY_DEPOSIT_ATM_CARDLESS,
  [TRANSACTION_TYPES.BANK_DEPOSIT_ATM_CARDLESS]: TRANSACTION_TYPES.BANK_DEPOSIT_ATM_CARDLESS,
  [TRANSACTION_TYPES.TJK_WON]: TRANSACTION_TYPES.TJK_WON,

};

export const NOT_WITHDRAWABLE_TYPES = [
  TRANSACTION_TYPES.BANK_DEPOSIT_ATM_CARDLESS,
  TRANSACTION_TYPES.BANK_GATEWAY_DEPOSIT_ATM_CARDLESS
];

export const DIRECTION = {
  INCOMING: 'INCOMING',
  OUTGOING: 'OUTGOING',
};

export const WITHDRAW_STATUS_CODES = {
  INITIAL: 'INITIAL',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL',
  CANCEL: 'CANCEL',
};

const {
  WITHDRAW,
  IDDAA_WON,
  ONLINE_WITHDRAW_ROLLBACK,
  ONLINE_WITHDRAW,
  WITHDRAW_REFUND,
  SPORTOTO_WON,
  BANK_GATEWAY_DEPOSIT_ATM_CARDLESS,
  BANK_DEPOSIT_ATM_CARDLESS,
  TJK_WON,
} = DETAILED_TRANSACTION_TYPES;

export const MODAL_MESSAGES = {
  [IDDAA_WON]: {
    title: 'İddaa Kupon Kazancı',
    message: EnvironmentManager.getMessageText({
      key: 'cah_iddaa_coupon_earnings',
    }),
    modalName: 'iddaaWon'
  },
  [SPORTOTO_WON]: {
    title: 'Spor Toto Kupon Kazancı',
    message: EnvironmentManager.getMessageText({
      key: 'cah_sportoto_coupon_earnings',
    }),
    modalName: 'sportotoWon'
  },
  [BANK_DEPOSIT_ATM_CARDLESS]: {
    title: 'Banka/ATM Kartsız İşlem',
    message: EnvironmentManager.getMessageText({
      key: 'cah_atm_deposit_info',
    }),
    modalName: 'bankDepositATMCardless'
  },
  [BANK_GATEWAY_DEPOSIT_ATM_CARDLESS]: {
    title: 'Banka/ATM Kartsız İşlem',
    message: EnvironmentManager.getMessageText({
      key: 'cah_atm_deposit_info',
    }),
    modalName: 'bankGatewayDepositATMCardless'
  },
  [ONLINE_WITHDRAW]: {
    IN_PROGRESS: {
      title: 'Banka İşlemi Başladı',
      message: EnvironmentManager.getMessageText({
        key: 'cah_bank_in_progress',
      }),
      modalName: 'onlineWithdrawInProgres'
    },
    SUCCESS: {
      title: 'Banka İşlemi Başarılı',
      message: EnvironmentManager.getMessageText({
        key: 'cah_succes_bank_process',
      }),
      modalName: 'onlineWithdrawSuccess'
    },
    FAIL: {
      title: 'Banka İşlemi Başarısız',
      message: EnvironmentManager.getMessageText({
        key: 'cah_failed_bank_process',
      }),
      modalName: 'onlineWithdrawFail'
    },
  },
  [WITHDRAW]: {
    INITIAL: {
      title: 'Banka İşlemi Başlamadı',
      message: EnvironmentManager.getMessageText({
        key: 'cah_workday_bank_process_type_not_started',
      }),
      modalName: 'withdrawInitial'
    },
    IN_PROGRESS: {
      title: 'Banka İşlemi Başladı',
      message: EnvironmentManager.getMessageText({
        key: 'cah_workday_bank_in_progress',
      }),
      modalName: 'withdrawInProgress'
    },
    SUCCESS: {
      title: 'Banka İşlemi Başarılı',
      message: EnvironmentManager.getMessageText({
        key: 'cah_workday_succes_bank_process',
      }),
      modalName: 'withdrawSuccess'
    },
    CANCEL: {
      title: 'Banka İşlemi İptal Edildi',
      message: EnvironmentManager.getMessageText({
        key: 'cah_workday_cancel_bank_process',
      }),
      modalName: 'withdrawCancel'
    },
    FAIL: {
      title: 'Banka İşlemi Başarısız',
      message: EnvironmentManager.getMessageText({
        key: 'cah_workday_failed_bank_process',
      }),
      modalName: 'withdrawFail'
    },
  },
  [ONLINE_WITHDRAW_ROLLBACK]: {
    title: 'Başarısız İşlem/Hatalı ya da Eksik IBAN',
    message: EnvironmentManager.getMessageText({
      key: 'cah_failed_bank_process',
    }),
    modalName: 'onlineWithdrawRollback'
  },
  [WITHDRAW_REFUND]: {
    title: 'Başarısız İşlem/Hatalı ya da Eksik IBAN',
    message: EnvironmentManager.getMessageText({
      key: 'cah_workday_failed_bank_process',
    }),
    modalName: 'withdrawRefund'
  },
  [TJK_WON]: {
    title: 'At Yarışı Kupon Kazancı',
    message: EnvironmentManager.getMessageText({
      key: 'description_coupon_details_earnings',
    }),
    modalName: 'tjkWon'
  },
};
